import {onetrustProvider} from './onetrust';
import {concordProvider} from './concord';

/**
 * Registry of all cookie banner providers
 * Providers are checked in order - first matching provider is used
 */
const providers = [
  onetrustProvider,
  concordProvider
];

/**
 * Finds the appropriate provider based on settings
 * @param {Object} settings - Application settings
 * @returns {Object|null} Provider instance or null if no provider matches
 */
export function getProvider(settings) {
  if (!settings) {
    return null;
  }

  for (const provider of providers) {
    if (provider.shouldUse(settings)) {
      return provider;
    }
  }

  return null;
}

/**
 * Gets the trigger ID for the current provider
 * Uses custom triggerId if provided, otherwise falls back to provider's default
 * @param {Object} settings - Application settings
 * @returns {string|null} Trigger element ID or null if no provider matches
 */
export function getTriggerId(settings) {
  // Custom triggerId takes precedence
  if (settings.cookieBanner?.triggerId) {
    return settings.cookieBanner.triggerId;
  }

  // Get provider and use its default trigger ID
  const provider = getProvider(settings);
  if (provider && provider.defaultTriggerId) {
    return provider.defaultTriggerId;
  }

  // Return null if no provider matches - let initializeCookieBanner() handle it
  return null;
}
